import React, { useState, useEffect, useCallback } from 'react'
import { useLocation, Link } from "react-router-dom";
import axios from 'axios';
import { IMAGE_URL } from '../Constants/constants';

// /search — shop directory, same card language as the homepage.
export default function SearchBusiness() {
	const [sellerData, setSellerData] = useState([]);
	const [query, setQuery] = useState('');
	const [loading, setLoading] = useState(true);
	const [failed, setFailed] = useState(false);
	const location = useLocation();

	const getBusiness = useCallback((params, attempt = 0) => {
		setLoading(true);
		setFailed(false);
		axios.get(`${process.env.REACT_APP_APP_API_URL}/api/sellers`, {
			headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
			params,
			timeout: 15000,
		}).then(res => {
			if (res.data.status === 200) setSellerData(res.data.sellers || []);
			setLoading(false);
		}).catch(() => {
			// the API machine may be waking up — retry once before giving up
			if (attempt < 1) return getBusiness(params, attempt + 1);
			setFailed(true);
			setLoading(false);
		});
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
		const initial = location.state || {};
		setQuery(initial.sr || '');
		getBusiness(initial);
	}, [location, getBusiness]);

	const submit = (e) => {
		e.preventDefault();
		getBusiness({ sr: query });
	};

	return (
		<div className="bp-results-page container">
			<div className="bp-results-head">
				<div>
					<span className="bp-sec-label" style={{ textAlign: 'left' }}>DIRECTORY</span>
					<h2 className="bp-sec-title">Shops <span className="bp-results-count">{loading ? '…' : `${sellerData.length} found`}</span></h2>
				</div>
				<form className="bp-results-search" onSubmit={submit}>
					<input
						value={query}
						placeholder="Search shops, categories, or cities…"
						onChange={e => setQuery(e.target.value)}
					/>
					<button type="submit" className="bp-btn-primary">Search</button>
				</form>
			</div>

			{loading ? (
				<div className="bp-results-empty"><p className="bp-dim">Searching the marketplace…</p></div>
			) : failed ? (
				<div className="bp-results-empty">
					<h3>Couldn't reach the marketplace</h3>
					<p className="bp-dim">The connection timed out — it usually works on a retry.</p>
					<button className="bp-btn-primary" style={{ marginTop: 14 }} onClick={() => getBusiness({ sr: query })}>Try Again</button>
				</div>
			) : sellerData.length === 0 ? (
				<div className="bp-results-empty">
					<h3>No shops found</h3>
					<p className="bp-dim">Try a different search, or browse everything from the homepage.</p>
					<Link to="/" className="bp-btn-ghost">Back to home</Link>
				</div>
			) : (
				<div className="bp-shops-grid">
					{sellerData.map((item) => (
						<Link to={"/businessnew/" + item._id} className="bp-shop-card" key={item._id}>
							<div className="bp-shop-cover">
								<img alt="" src={item.coverImage ? IMAGE_URL + item.coverImage : "/images/placeholder.svg"} />
							</div>
							<div className="bp-shop-avatar">
								<img alt="" src={item.image ? IMAGE_URL + item.image : "/images/placeholder.svg"} />
							</div>
							<div className="bp-shop-body">
								<h4>{item.businessName}</h4>
								<span className="bp-shop-chip">{item.businessType}</span>
								{(item.city || item.state) && (
									<span className="bp-shop-city">📍 {item.city}{item.city && item.state ? ', ' : ''}{item.state}</span>
								)}
								<span className="bp-shop-visit">Visit shop <i>→</i></span>
							</div>
						</Link>
					))}
				</div>
			)}
		</div>
	)
}
